export const VUUR = 'AIzaSyA3CaDFm5I2lqbrtsrPtc8s-EF6QB2h8Ag';

export const firebaseConfig = {
    apiKey: 'AIzaSyA3CaDFm5I2lqbrtsrPtc8s-EF6QB2h8Ag',
    authDomain: 'partyshot.firebaseapp.com',
    databaseURL: 'https://partyshot.firebaseio.com',
    projectId: 'partyshot',
    storageBucket: 'partyshot.appspot.com',
    messagingSenderId: '533427754917',
    appId: '1:533427754917:web:ac92ba717ecbe1c732fa4c',
    measurementId: 'G-277Z05HEDZ'
};